'use client';
import 'src/polyfills';

export const PolyfillProvider = ({ children }: React.PropsWithChildren) => {
  return children;
};
